<template lang="pug">
  ul.ods-actions-menu__ul.ods-actions-menu--user__ul
    li.user-ul__user-name
      | {{ completeName }}
      br
      | {{ username }}
      br
      br
      | {{ $t('msg_generics.date_last_connection') }}
      br
      | {{ lastConnectionDate }}
    li.ods-actions-menu__separator
    li
      lang-selector(cssClass="user-ul__languages")
    li.ods-actions-menu__separator
    router-link(
      tag="li"
      to="/profile")
      a
        ods-icon(name="user")
        | {{ $t('nav_header.profile') }}
    li.ods-actions-menu__separator
    li(@click='handleLogout')
      a(href='#')
        ods-icon(name="logout")
        | {{ $t('nav_header.logout') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import LangSelector from '@/components/shared/LangSelector'
import moment from 'moment'

export default {
  name: 'UserMenu',
  components: {
    LangSelector
  },
  data () {
    return {
      url: null
    }
  },
  computed: {
    ...mapGetters(['activeUser', 'urlIn']),
    completeName () {
      if (this.activeUser.data) {
        if (this.activeUser.data.firstSurname != null && this.activeUser.data.secondSurname != null) return this.activeUser.data.name + ' ' + this.activeUser.data.firstSurname + ' ' + this.activeUser.data.secondSurname
        else if (this.activeUser.data.firstSurname == null) return this.activeUser.data.name
        else return this.activeUser.data.name + ' ' + this.activeUser.data.firstSurname
      } else return ''
    },
    username () {
      if (this.activeUser.data) return this.activeUser.data.username
      else return ''
    },
    lastConnectionDate () {
      if (this.activeUser.data && this.activeUser.data.lastConnection) {
        const date = moment(this.activeUser.data.lastConnection)
        return date.format(this.$t('date_format_long'))
      } else return ''
    }
  },
  methods: {
    ...mapActions([
      'logout',
      'resetSession'
    ]),

    async handleLogout () {
      console.log('La url que llega al logout es', this.url)
      const titleLogout = this.$t('login.logout_correct')
      const load = this.$loading({
        lock: true
      })
      try {
        await this.resetSession()
        await this.logout(this.url)
        this.$notify({
          title: titleLogout,
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('LOGOUT CATCH: ', error)
        let errorSms = ''
        let statusCode = null
        statusCode = error.status
        switch (statusCode) {
          case 400:
            errorSms = this.$t('error.e400')
            break
          case 401:
            errorSms = this.$t('error.e401')
            // router.push({ name: 'login' })
            break
          case 500:
            errorSms = this.$t('error.e500')
            break
          default:
            errorSms = this.$t('error.default')
            break
        }
        this.$notify({
          title: errorSms,
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
      } finally {
        load.close()
        router.push({ path: this.url })
      }
    }
  },
  created () {
    console.log('Instancia de UserMenu creada: urlIn ', this.urlIn)
    console.log('isActive: ', this.activeUser.isActive)
    console.log('sessionStorage ', sessionStorage)
    const storelog = JSON.parse(sessionStorage.getItem('store'))
    console.log('storelog: ', storelog)
    console.log('this.$apiBaseUrl ', this.$apiBaseUrl)

    if (this.$apiBaseUrl && this.$apiBaseUrl !== null) {
      this.url = '/' + this.$apiBaseUrl
    } else if (this.urlIn && this.urlIn !== null) {
      if (this.urlIn === 'redelectrica') {
        this.url = '/ree'
      } else {
        this.url = '/' + this.urlIn
      }
    } else {
      this.url = '/login'
    }
    console.log('La url que vamos a manejar es', this.url)
  }
}
</script>

<style lang="scss" scoped>
  .user-ul__languages {
    ::v-deep .ods-input__inner {
      border: none;
    }
  }
</style>
